import { API_GATEWAY_URL } from 'shared/consts/consts';
import { serialize } from 'shared/helpers';

import BaseService from 'services/baseService';

const apiGateway = new BaseService(API_GATEWAY_URL);
const apiGatewayBlob = new BaseService(API_GATEWAY_URL, {
	responseType: 'blob',
});
export const AGENT_APIS = {
	getAllAgents() {
		const params = {
			targetApi: 'getAllAgents',
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	downloadAgent(uuid) {
		const params = {
			targetApi: 'downloadContextFile',
			uuid,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	downloadCDF() {
		const params = {
			targetApi: 'downloadCDFFile',
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	getAgentDetails(uuid) {
		const params = {
			targetApi: 'getAgentDetails',
			uuid,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	deleteAgent(uuid) {
		const params = {
			targetApi: 'deleteAgent',
			uuid,
		};

		return apiGateway.deleteRequest(serialize(params, '?'));
	},
	createAgent: (data) => {
		const params = {
			targetApi: 'createAgent',
		};

		return apiGateway.postRequest(data, serialize(params, '?'));
	},
	updateAgent(data) {
		const params = {
			targetApi: 'updateAgent',
			portalUserId: '{{userId}}',
		};

		return apiGateway.putRequest(data, serialize(params, '?'));
	},
	generatePrompt: (data) => {
		const params = {
			targetApi: 'generatePrompt',
		};

		return apiGateway.postRequest(data, serialize(params, '?'));
	},
	deployAIAgent: (uuid, isAgentDeployed) => {
		const params = {
			targetApi: 'deployAIAgent',
		};
		const body = {
			uuid,
			isAgentDeployed,
		};

		return apiGateway.putRequest(body, serialize(params, '?'));
	},
	setAgentAsDefault: (uuid) => {
		const params = {
			targetApi: 'setDefaultAgent',
		};
		const body = {
			uuid,
		};

		return apiGateway.putRequest(body, serialize(params, '?'));
	},

	getAgentsWorkflows: () => {
		const params = {
			targetApi: 'getAgentsWorkflows',
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	saveAgentWorkflow: (data) => {
		const params = {
			targetApi: 'saveAgentWorkflow',
		};

		return apiGateway.postRequest(data, serialize(params, '?'));
	},
	updateAgentWorkflow: (data) => {
		const params = {
			targetApi: 'updateAgentWorkflow',
		};

		return apiGateway.putRequest(data, serialize(params, '?'));
	},
	deleteAgentWorkflow: (workflowName) => {
		const params = {
			targetApi: 'deleteAgentWorkflow',
			workflowName,
		};

		return apiGateway.deleteRequest(serialize(params, '?'));
	},
	checkAgentName: (agentName) => {
		const params = {
			targetApi: 'checkDuplicateName',
			name: agentName,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	generateSupervisorInstruction: (selectedAgents) => {
		const params = {
			targetApi: 'getSupervisorInstruction',
		};

		return apiGateway.postRequest(selectedAgents, serialize(params, '?'));
	},
	saveSupervisorConfig: (requestBody) => {
		const params = {
			targetApi: 'saveSupervisorConfig',
			portalUserId: '{{userId}}',
		};

		return apiGateway.putRequest(requestBody, serialize(params, '?'));
	},
	getSupervisorDetails: () => {
		const params = {
			targetApi: 'getSupervisorDetails',
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	getAgentsAggregatedData: (data) => {
		const params = {
			targetApi: 'agentsAggregatedData',
		};

		return apiGateway.postRequest(data, serialize(params, '?'));
	},
	getAgentsOverviewData: (data) => {
		const params = {
			targetApi: 'agentsOverviewTabData',
		};

		return apiGateway.postRequest(data, serialize(params, '?'));
	},
	exportAgentsAggregatedData: (data) => {
		const params = {
			targetApi: 'agentsAggregatedDataExport',
		};

		return apiGatewayBlob.postRequest(data, serialize(params, '?'));
	},
	getQcOrSummaryDetails(params) {
		return apiGateway.getRequest(serialize(params, '?'));
	},
	getProviderNameMap() {
		const params = {
			targetApi: 'getVoiceProviderNameMap',
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	getVoiceNameList(providerName, mode) {
		const params = {
			targetApi: 'getAgentVoiceNames',
			providerName,
			mode,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	getAnalyticsData(params) {
		return apiGateway.getRequest(serialize(params, '?'));
	},
	getVoiceCallRecording: (key) => {
		const params = {
			targetApi: 'getCallRecording',
			key,
		};

		return apiGatewayBlob.getRequest(serialize(params, '?'));
	},
	getVoiceCallRecordingBySessionId(data) {
		const params = {
			targetApi: 'getCallRecordingBySessionId',
			session_id: data,
		};

		return apiGatewayBlob.getRequest(serialize(params, '?'));
	},
	getRecordingConfig() {
		const params = {
			targetApi: 'getRecordingConfig',
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	saveRecordingConfig({ customerId, botRef, enable_recordings, recordings_expiry_days }) {
		const params = {
			targetApi: 'saveRecordingConfig',
			customerId,
			botRef,
			isRecordingEnabled: enable_recordings,
			...(enable_recordings && recordings_expiry_days != null
				? { recordingExpiryDays: recordings_expiry_days }
				: {}),
		};

		return apiGateway.postRequest(null, serialize(params, '?'));
	},
	getAllVoices(providerName, languageCode) {
		const params = {
			targetApi: 'getAllVoices',
			...(providerName && { provider_name: providerName }),
			...(languageCode && { language_code: languageCode }),
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	generateVoice(providerName, data) {
		const params = {
			targetApi: 'generateVoice',
			replaceable_params: {
				providerName,
			},
		};

		return apiGatewayBlob.postRequest(data, serialize(params, '?'));
	},

	cloneVoice(providerName, formData) {
		const params = {
			targetApi: 'cloneVoice',
			replaceable_params: {
				providerName,
			},
		};

		return apiGateway.postRequest(formData, serialize(params, '?'));
	},

	importVoice(providerName, voiceId) {
		const params = {
			targetApi: 'importVoice',
			replaceable_params: {
				providerName,
				voiceId,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	getProvidersByFeature(action) {
		const params = {
			targetApi: 'getProvidersByFeature',
			replaceable_params: {
				action,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	getVoiceByType(type) {
		const params = {
			targetApi: 'getVoiceByType',
			replaceable_params: {
				type,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	getProviderIngressConfig(provider) {
		const params = {
			targetApi: 'getProviderIngressConfig',
			replaceable_params: {
				provider,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	saveProviderIngressConfig(provider, data) {
		const params = {
			targetApi: 'saveProviderIngressConfig',
			replaceable_params: {
				provider,
			},
		};

		return apiGateway.putRequest(data, serialize(params, '?'));
	},

	deleteProviderIngressConfig(provider) {
		const params = {
			targetApi: 'deleteProviderIngressConfig',
			replaceable_params: {
				provider,
			},
		};

		return apiGateway.deleteRequest(serialize(params, '?'));
	},

	getProviderActionConfig(provider, event) {
		const params = {
			targetApi: 'getProviderActionConfig',
			replaceable_params: {
				provider,
				event,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	saveProviderActionConfigs(provider, actions) {
		const params = {
			targetApi: 'saveProviderActionConfigs',
			replaceable_params: {
				provider,
			},
		};

		return apiGateway.putRequest({ actions }, serialize(params, '?'));
	},

	deleteProviderActionConfig(provider, event) {
		const params = {
			targetApi: 'deleteProviderActionConfig',
			replaceable_params: {
				provider,
				event,
			},
		};

		return apiGateway.deleteRequest(serialize(params, '?'));
	},

	getPronunciationDictionary(botRef, agentId) {
		const params = {
			targetApi: 'getPronunciationDictionary',
			replaceable_params: {
				botRef,
				agentId,
				uuid: agentId,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	getDefaultConversationConfig({ botRef, isVoiceAgent, voiceMode, voiceProvider, preset }) {
		const params = {
			targetApi: 'getDefaultConversationConfig',
			replaceable_params: {
				botRef,
			},
			isVoiceAgent,
			voiceMode,
			voiceProvider,
			...(preset ? { preset } : {}),
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
	createPronunciationDictionary(botRef, agentId, data) {
		const params = {
			targetApi: 'createPronunciationDictionary',
			replaceable_params: {
				botRef,
				agentId,
				uuid: agentId,
			},
		};

		return apiGateway.postRequest(data, serialize(params, '?'));
	},
	updatePronunciationDictionary(botRef, agentId, data) {
		const params = {
			targetApi: 'updatePronunciationDictionary',
			replaceable_params: {
				botRef,
				agentId,
				uuid: agentId,
			},
		};

		return apiGateway.putRequest(data, serialize(params, '?'));
	},
	exportSessions(customerId, botRef, data) {
		const params = {
			targetApi: 'agentsAggregatedDataExport',
			replaceable_params: {
				customerId,
				botRef,
			},
			...data,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	getExportStatus(exportId) {
		const params = {
			targetApi: 'getAgentExportStatus',
			replaceable_params: {
				exportId,
			},
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	getExportHistory(customerId, botRef, page = 1, size = 10) {
		const params = {
			targetApi: 'getAgentExportHistory',
			replaceable_params: {
				customerId,
				botRef,
			},
			page: page - 1,
			size,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},

	downloadExportHistory(fileToken) {
		const params = {
			targetApi: 'downloadImportHistory',
			token: fileToken,
		};

		return apiGateway.getRequest(serialize(params, '?'));
	},
};
